import classNames from 'classnames';
import { User } from 'react-feather';
import { ParsedReservationDetails } from '@src/@data/types/reservations';
import { SquaredThumbnail } from '@appcomponents/atoms/squared-thumbnail';

interface CalendarInfoProps {
  className?: string;
  calendar: Pick<ParsedReservationDetails['calendar'], 'image' | 'title'>;
  label?: string;
}

export const CalendarInfo: React.FC<CalendarInfoProps> = ({
  calendar,
  className,
  label,
}) => {
  return (
    <div className={classNames(className, 'd-flex')}>
      <SquaredThumbnail thumbnail={calendar.image?.thumbnail} className="mr-75">
        {!calendar.image?.thumbnail && (
          <User
            size={20}
            fill="#7180B7"
            stroke="#7180B7"
            strokeLinecap="butt"
          />
        )}
      </SquaredThumbnail>
      <div
        className={classNames(
          'd-flex flex-column',
          !label && 'align-self-center'
        )}
      >
        {!!label && <small className="text-secondary">{label}</small>}
        <span>{calendar.title}</span>
      </div>
    </div>
  );
};
